export const regexp = {
  findSymbols: /{.+?}|[^\s]/g,
  findSpecialKeyText: /[^{}\|]+(?=})/g,
  findSpecialKeyValue: /[^{}\|\s]+/,
  findLangBtn: /{lang}/g,
  findBrackets: /{|}/g,
  findShiftCapsKeys: /caps|shift/g
};
